/* istanbul ignore file */
/**
 * Created by rathompson on 12/17/21
 * File: TreeReducer.actions.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// Action Types
export const LOAD_TREE_DATA = 'LOAD_TREE_DATA'
export const SELECTED_TREE_NODE = 'SELECTED_TREE_NODE'
export const LOAD_INSTANCE_DATA = 'LOAD_INSTANCE_DATA'
export const ON_EXPANDED_KEY = 'ON_EXPANDED_KEY'
export const LOAD_TENANT_INSTANCE_DATA = 'LOAD_TENANT_INSTANCE_DATA'
export const LOAD_CHILD_INSTANCE_DATA = 'LOAD_CHILD_INSTANCE_DATA'
export const LOAD_TSG_ID = 'LOAD_TSG_ID'
export const RESET_TREE_DATA = 'RESET_TREE_DATA'
export const LOAD_ACQUISITIONS = 'LOAD_ACQUISITIONS'
export const LOAD_ACQ_REQUESTS = 'LOAD_ACQ_REQUESTS'
export const SET_ACQ_LOADING = 'SET_ACQ_LOADING'

// Action Creators
export const loadTreeData = (sgTree = []) => ({
  type: LOAD_TREE_DATA,
  sgTree
})

export const selectTreeNode = (selectedNode) => ({
  type: SELECTED_TREE_NODE,
  selectedNode
})

export const loadInstanceData = (instances) => ({
  type: LOAD_INSTANCE_DATA,
  instances
})

export const onExpandedKey = (expandedKeys) => ({
  type: ON_EXPANDED_KEY,
  expandedKeys
})

export const loadChildInstanceData = (instances) => ({
  type: LOAD_CHILD_INSTANCE_DATA,
  instances
})

export const resetTreeData = () => ({
  type: RESET_TREE_DATA
})

export const loadAcquisitions = (acquisitions) => ({
  type: LOAD_ACQUISITIONS,
  acquisitions
})

export const loadAcqRequests = (acquisition_requests) => ({
  type: LOAD_ACQ_REQUESTS,
  acquisition_requests
})

export const setAcqLoading = (acqLoading) => ({
  type: SET_ACQ_LOADING,
  acqLoading
})
